import React, { useState,useEffect } from "react";

import { Box, Typography} from "@mui/material";
import Footer from "./Footer";





const IndustriesHome = () => {
   

    const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
          window.scrollTo(0, 0); // Scroll to top when component loads
        },[]);

    const industries = [
        { title: "Automobile", image: "/image/industry_automobile1.jpg", link: "/automobile" },
        { title: "Healthcare", image: "/image/industry_health1.jpg", link: "/health" },
        { title: "Banking & Finance",image: "/image/industry_bank1.jpg", link: "/banking" },
        { title: "Education",image: "/image/industry_education1.jpg", link: "/education" },
        { title: "Retail",image: "/image/retail.jpg", link: "/retail" },
        { title: "Manufacturing", image: "/image/manufacturing1.jpg", link: "/manufacturing" },
       
      
      ];

    const description = `Tech informatic Solutions has in-depth industry knowledge. This makes us a top provider of business advisory and IT services. Working with sectors like healthcare, public sector, manufacturing and financial services, we use creative problem-solving methods to achieve success. We also have extensive technology expertise, and offer full-stack services and flexible payment options. Working with strategic partners, we help businesses achieve real results.`;

    const containerStyle = {
        padding: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
        paddingBottom: "100px", 
      };
    
      const descriptionStyle = {
        fontSize: isMobile ? "1rem" : "1.2rem",
        lineHeight: "1.6",
        marginBottom: "40px",
        color: "#333",
       // fontFamily:"Roboto"
      };
      
          
      const gridStyle = {
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
        gap: "20px",
      };

      
      const cardStyle = {
        position: "relative",
        height: "200px",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "8px",
        overflow: "hidden",
        cursor: "pointer",
        
      };
    
      const overlayStyle = {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        height: "100%",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "20px",
      };
    
      const titleStyle = {
        margin: "0 0 10px",
        fontSize: "18px",
      };
    
      const ReadMore = ({ text, link }) => {
        const [hover, setHover] = useState(false);
    
        return (
          <div
            style={{
              display: "inline-block",
              cursor: "pointer",
              color: "#fff",
              fontWeight: "bold",
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => (window.location.href = link)}
          >
            <div style={{ position: "relative", display: "inline-block" }}>
              <span>{text}</span>
              <div
                style={{
                  height: "2px",
                  backgroundColor: "#fff",
                  width: hover ? "100%" : "0%",
                  transition: "width 0.3s ease",
                  marginTop: "2px",
                }}
              />
            </div>
          </div>
        );
      };

return (
    <>
      {/* First Section - Background Image */}
      <Box
  sx={{
    position: "relative",
    width: "100%",
    minHeight: "70vh", // Use minHeight instead of fixed height
    backgroundImage: `url("/image/industryhome.png")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    color: "white",
    overflow: "hidden", // Prevents content from spilling over
  }}
>
  {/* Dark overlay for readability */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }}
  />

  {/* Content Box */}
  <Box
    sx={{
      position: "relative",
      maxWidth: "700px",
      marginLeft: { xs: "3%", md: "8%" },
      marginTop: { xs: "15%", md: "10%" }, // Reduce margin to avoid overflow
      zIndex: 1,
      padding: 4,
      
    }}
  >
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: "bold", 
        mb: 2, 
        fontSize: { xs: "28px", md: "42px" }, // Reduce size slightly for better fit
      }}
    >
     Industries
    </Typography>
    <Typography 
      variant="body1" 
      sx={{ 
        fontSize: { xs: "14px", md: "18px" }, 
        maxWidth: "100%", 
        wordBreak: "break-word", 
        lineHeight: 1.5, 
      }}
    >
     We combine deep industry knowledge with cross-industry perspective to uncover—and deliver—the best solution to any challenge. In a changing world, the right answer is rarely the most familiar.
    </Typography>
  </Box>
</Box>
   



{/*second seection*/}
<div style={containerStyle}>
      <p style={descriptionStyle}>{description}</p>
      <div style={gridStyle}>
        {industries.map((item, idx) => (
          <div
            key={idx}
            style={{ ...cardStyle, backgroundImage: `url(${item.image})` }}
          >
            <div style={overlayStyle}>
              <h3 style={titleStyle}>{item.title}</h3>
              <ReadMore text="Read more →" link={item.link} />
            </div>
          </div>
        ))}
      </div>
    </div>



<Footer/>
    </>
  );
};
export default IndustriesHome;